import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20luxurious%20dark%20gaming%20atmosphere%20with%20golden%20abstract%20geometric%20patterns%20and%20flowing%20light%20trails%2C%20elegant%20dark%20background%20with%20warm%20golden%20accents%2C%20premium%20sophisticated%20style%2C%20dramatic%20lighting%20with%20deep%20shadows%20and%20golden%20highlights%2C%20cinematic%20ultra%20wide%20composition%20with%20luxurious%20texture&width=1800&height=900&seq=hero-bg-main-001&orientation=landscape"
          alt="必赢亚洲 - 亚洲顶级娱乐游戏平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
            <i className="ri-shield-check-line text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs text-primary-300 font-medium">官方正版授权 · PAGCOR合法牌照</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6">
            必赢亚洲
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-background-200">
              安全畅玩 赢无止境
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。
            官方正版授权，安全存取款，极速到账，24小时客服全程护航。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
            >
              立即注册
            </a>
            <a
              href="#categories"
              className="px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium text-base rounded-md border border-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-14 max-w-3xl mx-auto">
            {heroData.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-400 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl w-8 h-8 flex items-center justify-center"></i>
      </div>
    </section>
  );
}